import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GoogleAnalyticsEventService } from '@services/google-analytics-events.service.service';

@Component({
  selector: 'app-support-versions',
  templateUrl: './support-versions.component.html',
  styleUrls: ['../support-page.component.scss'],
})
export class SupportVersionsComponent implements OnChanges {

  @Input() isVisible: boolean = false;

  constructor(
    private gaService: GoogleAnalyticsEventService,
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isVisible.currentValue) {
      this.sendGATracking();
    }
  }

  /**
   * Track Google Analytics
   *
   */
  sendGATracking() {

    this.gaService.sendEvent('Support', 'Versions', 'View', 1);

  }

  /**
   * Track clicking external link
   *
   * @param url
   */
  trackOutboundLink(url: string) {

    this.gaService.sendEvent('Support', 'Versions', 'Outbound Link - ' + url, 1);

  }

}
